import { render, staticRenderFns } from "./CarouselBox.vue?vue&type=template&id=5793bcf7&"
import script from "./CarouselBox.vue?vue&type=script&lang=js&"
export * from "./CarouselBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports